import Axios from 'axios'
import store from '@/plugins/store'

import devConfig from './axios.dev.config'
import prodConfig from './axios.prod.config'
import getErrorMessage from './expectionalError'
import { queryStr } from '@/utils/json'

import { Message } from 'element-ui'
import router from '../router'

const isDev = process.env.NODE_ENV !== 'production'
const instance = Axios.create(isDev ? devConfig : prodConfig)
const toLogin = [406, 1001102]
const noMessage = [1001206]
const unlogs = ['/mgt/file/url']
let errMsg = null

/**
 * 请求拦截器
 * 请求前的统一逻辑处理
 */
instance.interceptors.request.use(function (config) {
  store.state.user && (config.headers.token = store.state.user.token)
  return config
}, requestErrorHandler)

/**
 * 响应拦截器
 * 请求后的统一逻辑处理
 */
instance.interceptors.response.use(function (response) {
  isDev && !unlogs.every((item) => response.config.url.indexOf(item) === 0) && console.log(response.config.url + '\n', response)
  if (response.request.responseType === 'json') {
    if (!response.data) { return response }
    if (response.data.status !== 200) {
      // 定义错误对象
      let err = {
        config: response.config,
        request: response.request,
        header: response.header,
        response: {data: {status: response.data.status, description: response.data.message}}
      }
      // 抛出错误
      return responseErrorHandler(err)
    } else {
      return response.data
    }
  } else {
    return response
  }
}, responseErrorHandler)

/**
 * 处理请求错误
 * @param {Object} error
 */
function requestErrorHandler (error) {
  return Promise.reject(error)
}

/**
 * 统一处理响应错误
 * @param {Object} error
 */
function responseErrorHandler (error) {
  // 自定义错误
  const err = getErrorMessage(error)
  isDev && console.error(error.config.url, error, err)
  
  if (!noMessage.includes(err.status)) {
    // 错误提示
    errMsg && errMsg.close()
    errMsg = Message.error(err.description)
  }
  
  if (toLogin.includes(err.status)) {
    router.push({name: 'login'})
  }
  // 因为 return 而非 reject，所以 await 正常返回，加一个 data: {}，防止 const {data, status} = res 时报错
  return {data: {}, status: err.status}
}

window.$get = (url, params = {}, config = {}) => {
  return instance.get(`${url}${queryStr(params)}`, config)
}
window.$post = instance.post
window.$delete = instance.delete
window.$put = instance.put
window.$axios = instance
